<div class="website-content" style="max-width:72rem;padding:0 var(--wa-spacing-x-large) var(--wa-spacing-x-large) var(--wa-spacing-x-large);">
	<div class="wa-stack wa-gap-xl">
		<div class="wa-stack wa-gap-m content-section">
			<wa-divider class="section-divider"></wa-divider>
			<div class="wa-stack wa-gap-s">
				<div class="hero-eyebrow" waCaption="s" waFontWeight="semibold" waText>CHOOSING A PATTERN</div>
				<h2 waHeading="l" waText>When to Use What</h2>
				<p waBody="m" waColorText="quiet" waText>Start with REST and AJAX. Add real-time when you need it.</p>
			</div>
			<div class="wa-stack wa-gap-m">
				<p waBody="m" waText>Most applications start with REST and AJAX &mdash; they cover the majority of client-server interactions. Add real-time when your use case demands it. All patterns coexist in the same application.</p>
				<div class="wa-grid wa-gap-m" style="--min-column-size:20rem;">
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>REST &amp; AJAX &mdash; The Default</h3>
							<p waBody="m" waColorText="quiet" waText>Standard request/response. REST endpoints for API consumers. AJAX events for interactive UI. Data services for typed data fetching. No WebSocket infrastructure needed.</p>
							<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Always available</div>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Vert.x Event Bus &mdash; Zero-Infra Push</h3>
							<p waBody="m" waColorText="quiet" waText>Add push updates without a broker. Plugin data push &#40;AG Grid, Chart.js, FullCalendar&#41;. Single-instance deployments. Rapid prototyping.</p>
							<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Built-in with Angular plugin</div>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>RabbitMQ &mdash; Production Scale</h3>
							<p waBody="m" waColorText="quiet" waText>Multi-instance deployments. Durable message delivery. Broker-managed routing and persistence. SLA requirements.</p>
							<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Requires RabbitMQ broker</div>
						</div>
					</wa-card>
					<wa-card appearance="outlined" class="feature-card">
						<div class="wa-stack wa-gap-s">
							<h3 class="feature-card-title" waHeading="m" waText>Mix and Match</h3>
							<p waBody="m" waColorText="quiet" waText>REST for your API. AJAX for form submissions. Vert.x event bus for grid data push. RabbitMQ for cross-instance notifications. All in the same app.</p>
							<div class="feature-card-note" waCaption="s" waColorText="quiet" waFontWeight="semibold" waText>Composable</div>
						</div>
					</wa-card>
				</div>
			</div>
		</div>
	</div>
</div>